import { createSlice } from '@reduxjs/toolkit';
import { APP_ID } from '../constants';
import {
  Deductible,
  DistributionChannel,
  Gender,
  PaymentMode,
  PaymentSource,
  Relationship,
} from '../enums';
import { Plan } from '../types/model';
import { Action } from '../types/reducers/actions';
import { ApplicationState } from '../types/reducers/application';
import { PlanCode } from '../enums/planCode';

const initialState: ApplicationState = {
  appId: APP_ID,
  distributionChannel: DistributionChannel.Online,
  paymentMode: PaymentMode.Annually,
  paymentSource: PaymentSource.CreditCard,
  deductible: Deductible.deductible500,
  plans: [] as Plan[],
  formValues: {
    quotation: {
      life_insured: {
        gender: Gender.MALE,
        relationship: Relationship.Self,
      },
    },
  },
  premiums: {},
  isDeclined: false,
  uwRemarks: '',
  planCode: PlanCode.PlanTwo,
};

export const applicationReducer = createSlice({
  name: 'application',
  initialState: initialState as ApplicationState,
  reducers: {
    updateFormValues: (
      state,
      action: Action<Partial<ApplicationState['formValues']>>,
    ) => {
      state.formValues = {
        ...state.formValues,
        ...action.payload,
      };
    },
    updatePlans: (state, action: Action<ApplicationState['plans']>) => {
      state.plans = [...action.payload];
    },
    updatePremiums: (
      state,
      action: Action<Partial<ApplicationState['premiums']>>,
    ) => {
      state.premiums = {
        ...state.premiums,
        ...action.payload,
      };
    },
    updateisDeclined: (state, action: Action<boolean>) => {
      state.isDeclined = action.payload;
    },
    updateUwRemarks: (state, action: Action<string>) => {
      state.uwRemarks = action.payload;
    },
    updatePlanCode: (state, action: Action<string>) => {
      state.planCode = action.payload;
    },
    updateDeductible: (state, action: Action<Deductible>) => {
      state.deductible = action.payload;
    },
    updatePaymentMode: (state, action: Action<PaymentMode>) => {
      state.paymentMode = action.payload;
    },
    updateRefId: (state, action: Action<string>) => {
      state.refId = action.payload;
    },
    updateIsEdit: (state, action: Action<boolean>) => {
      state.isEdit = action.payload;
    },
    updateAgent: (
      state,
      action: Action<{
        agent: ApplicationState['agent'];
        isValidAgent?: boolean;
      }>,
    ) => {
      state.agent = action.payload.agent;
      state.isValidAgent = action.payload.isValidAgent;
    },
    updateAgentVerification: (state, action: Action<boolean>) => {
      state.isVerifiedAgent = action.payload;
    },
    resetState: () => {
      return initialState as ApplicationState;
    },
  },
});

export const {
  updateFormValues,
  updatePlans,
  updatePremiums,
  updatePlanCode,
  updateDeductible,
  updatePaymentMode,
  updateRefId,
  updateIsEdit,
  updateAgent,
  updateAgentVerification,
  updateisDeclined,
  updateUwRemarks,
  resetState,
} = applicationReducer.actions;
